import dayjs from 'dayjs';
import { navStore, } from '@mcn-platform/models';
import { Tokens } from '@mcn-platform/converse-lib';
import navigationActions from './navigationActions';
const itemTypeTokenKey = (item) => {
    if (item.isProgram()) {
        return 'programName';
    }
    if (item.isMicrocast()) {
        return 'microcastName';
    }
    return 'courseName';
};
const hasAccessButtonLabeller = (portal, item, itemProgress) => {
    const itemTypeLabel = portal.getToken(itemTypeTokenKey(item));
    if (itemProgress?.progress === 100) {
        return portal.getToken('retakeLabel', { itemName: itemTypeLabel });
    }
    if (itemProgress?.startedDate) {
        return portal.getToken('continueLabel', { itemName: itemTypeLabel });
    }
    return portal.getToken('startLabel', { itemName: itemTypeLabel });
};
const hasRecording = (meeting) => !(!meeting.recording);
const configureAssetCard = (portal, item, navigate, location, rootPath) => {
    const asset = item;
    console.log('asset', asset);
    return {
        showPrice: false,
        showButton: true,
        buttonLabel: 'View Asset',
        action: () => {
            navigate(`${rootPath}/asset/${item.slug || item.key}`);
        },
        instructorAction: navigationActions(navigate, location, rootPath).instructorAction,
    };
};
const configureDocumentCard = (portal, item, navigate, location, rootPath) => {
    const document = item;
    console.log('document', document);
    return {
        showPrice: false,
        showButton: true,
        buttonLabel: 'View Document',
        action: () => {
            navigate(`${rootPath}/document/${item.slug || item.key}`);
        },
        instructorAction: navigationActions(navigate, location, rootPath).instructorAction,
    };
};
const getPreMeetingButtonLabel = (portal, meeting, registration) => {
    if (registration?.status === 'REGISTERED') {
        return portal.getToken('registeredLabel');
    }
    if (registration?.status === 'INVITED') {
        return portal.getToken('acceptInviteLabel');
    }
    // todo - verify if they have access to register first
    return portal.getToken('registerLabel');
};
const configureMeetingCard = (portal, meeting, registration, navigate, location, rootPath) => {
    console.log('meeting', meeting);
    // if meeting is in the future, show the register button
    if (meeting.status === 'PRE_MEETING') {
        const buttonLabel = getPreMeetingButtonLabel(portal, meeting, registration);
        return {
            showPrice: false,
            showButton: true,
            buttonLabel,
            action: () => {
                navigate(`${rootPath}/meeting/${meeting.key}`);
            },
            instructorAction: navigationActions(navigate, location, rootPath).instructorAction,
        };
    }
    if (meeting.status === 'OPEN' || meeting.status === 'ACTIVE') {
        return {
            showPrice: false,
            showButton: true,
            buttonLabel: portal.getToken('joinMeetingLabel'),
            action: () => {
                navigate(`${rootPath}/meeting/${meeting.key}`);
            },
            instructorAction: navigationActions(navigate, location, rootPath).instructorAction,
        };
    }
    return {
        showPrice: false,
        showButton: true,
        buttonLabel: portal.getToken('viewRecordingLabel'),
        action: () => {
            navigate(`${rootPath}/meeting/${meeting.key}`);
        },
        instructorAction: navigationActions(navigate, location, rootPath).instructorAction,
    };
};
const hasAccessItemAction = (portal, isProgramLandingPage, item, navigation) => {
    if (isProgramLandingPage) {
        return portal.programLandingWithAccessCourseAction === 'landing'
            ? navigation.landingPage(item)
            : navigation.deliveryPage(item);
    }
    if (portal.type === 'public') {
        return portal.publicCardAction === 'landing'
            ? navigation.landingPage(item)
            : navigation.deliveryPage(item);
    }
    if (portal.type === 'membership') {
        return portal.membershipCardWithAccessAction === 'landing'
            ? navigation.landingPage(item)
            : navigation.deliveryPage(item);
    }
    if (portal.type === 'commerce') {
        return portal.commerceCardWithAccessAction === 'landing'
            ? navigation.landingPage(item)
            : navigation.deliveryPage(item);
    }
    throw Error(`Portal type not recognized ${portal.type}`);
};
export const configureSalesCard = (portal, item, // TODO - create a type for this
itemProgress, navigate, location, rootPath, isProgramLandingPage = false, locale) => {
    // do meeting as a special case
    if (item.isMeeting()) {
        return configureMeetingCard(portal, item, itemProgress, navigate, location, rootPath);
    }
    if (item.isAsset()) {
        return configureAssetCard(portal, item, navigate, location, rootPath);
    }
    if (item.isDocument()) {
        return configureDocumentCard(portal, item, navigate, location, rootPath);
    }
    const nav = navigationActions(navigate, location, rootPath);
    const tokens = new Tokens(portal);
    if (locale) {
        tokens.setLocale(locale);
    }
    const hasAccess = portal.type === 'public' || !item.checkAccess || item.checkAccess();
    if (item.isProgram()) {
        const showButton = portal.membershipCardShowActionButton;
        const buttonLabel = hasAccess
            ? portal.membershipCardWithAccessButtonLabel
                || hasAccessButtonLabeller(portal, item, itemProgress)
            : portal.membershipCardNoAccessButtonLabel || 'Learn More';
        const action = nav.deliveryPage(item);
        if (hasAccess) {
            if (portal.courseDeliveryPage) {
                return {
                    showPrice: false,
                    showButton,
                    buttonLabel,
                    action,
                    instructorAction: nav.instructorAction,
                };
            }
        }
    }
    if (portal.type === 'public') {
        // const hasAccess = true;
        const showButton = portal.publicCardShowActionButton;
        const buttonLabel = portal.publicCardButtonLabel
            || hasAccessButtonLabeller(portal, item, itemProgress);
        const action = hasAccessItemAction(portal, isProgramLandingPage, item, nav);
        return {
            showPrice: false,
            showButton,
            buttonLabel,
            action,
            instructorAction: nav.instructorAction,
        };
    }
    if (portal.type === 'membership') {
        const showButton = portal.membershipCardShowActionButton;
        const buttonLabel = hasAccess
            ? portal.membershipCardWithAccessButtonLabel
                || hasAccessButtonLabeller(portal, item, itemProgress)
            : portal.membershipCardNoAccessButtonLabel || 'Learn More';
        let action;
        if (hasAccess) {
            action = hasAccessItemAction(portal, isProgramLandingPage, item, nav);
            // no access from here down
        }
        else if (portal.membershipCardNoAccessAction === 'landing') {
            action = nav.landingPage(item);
        }
        else if (portal.membershipCardNoAccessAction === 'offerPage') {
            action = nav.membershipOfferPage();
        }
        else if (portal.membershipCardNoAccessAction === 'checkout') {
            action = nav.membershipCheckout(portal.primaryMembership?.id);
        }
        else {
            console.log('No action defined');
        }
        return {
            showPrice: false,
            showButton,
            buttonLabel,
            action,
            instructorAction: nav.instructorAction,
        };
    }
    if (portal.type === 'commerce') {
        const showButton = portal.commerceCardShowActionButton;
        const buttonLabel = hasAccess
            ? tokens.resolvePortalText(portal.commerceCardWithAccessButtonLabel, 'commerceCardWithAccessButtonLabel') || hasAccessButtonLabeller(portal, item, itemProgress)
            : tokens.resolvePortalText(portal.commerceCardNoAccessButtonLabel, 'commerceCardNoAccessButtonLabel');
        let action;
        if (hasAccess) {
            action = hasAccessItemAction(portal, isProgramLandingPage, item, nav);
            // no access from here down
        }
        else if (portal.commerceCardNoAccessAction === 'landing') {
            action = nav.landingPage(item);
        }
        else if (portal.commerceCardNoAccessAction === 'checkout') {
            if (item.isCourse()) {
                action = nav.courseCheckout(item.key);
            }
            else {
                action = nav.programCheckout(item.key);
            }
        }
        else {
            console.log('Action not recognized');
        }
        return {
            showPrice: portal.cardShowPrice && !hasAccess,
            showButton,
            buttonLabel,
            action,
            instructorAction: nav.instructorAction,
        };
    }
    throw Error(`Portal type not recognized ${portal.type}`);
};
export const configLandingPage = (portal, item, itemProgress, navigate, location, rootPath, locale) => {
    const nav = navigationActions(navigate, location, rootPath);
    const tokens = new Tokens(portal);
    if (locale) {
        tokens.setLocale(locale);
    }
    const startProgram = async () => {
        if (!itemProgress) {
            navStore.showBlockInput();
            await item.startProgram();
            navStore.clearBlockInput();
        }
        const elem = document.getElementById('SyllabusContent');
        elem?.scrollIntoView();
    };
    const hasAccessButtonLabel = hasAccessButtonLabeller(portal, item, itemProgress);
    const hasAccess = portal.type === 'public' || !item.checkAccess || item.checkAccess();
    if (portal.type === 'public') {
        // const hasAccess = true;
        const buttonLabel = portal.publicLandingPageButtonLabel || hasAccessButtonLabel;
        const action = item.isProgram()
            ? startProgram
            : nav.deliveryPage(item);
        return {
            showPrice: false,
            buttonLabel,
            action,
            instructorAction: nav.instructorAction,
        };
    }
    if (portal.type === 'membership') {
        const buttonLabel = hasAccess
            ? portal.membershipLandingPageWithAccessButtonLabel || hasAccessButtonLabel
            : portal.membershipLandingPageNoAccessButtonLabel || 'Learn More';
        let action;
        if (hasAccess) {
            action = item.isProgram() ? startProgram : nav.deliveryPage(item);
        }
        else {
            if (portal.membershipLandingPageNoAccessMembershipAction === 'offerPage') {
                action = nav.membershipOfferPage();
            }
            else if (portal.membershipLandingPageNoAccessMembershipAction === 'checkout') {
                action = nav.membershipCheckout(portal.primaryMembership?.id);
            }
            console.log('No action defined');
        }
        return {
            showPrice: false,
            buttonLabel,
            action,
            instructorAction: nav.instructorAction,
        };
    }
    if (portal.type === 'commerce') {
        const buttonLabel = hasAccess
            ? tokens.resolvePortalText(portal.commerceLandingPageWithAccessButtonLabel, 'commerceLandingPageWithAccessButtonLabel') || hasAccessButtonLabel
            : tokens.resolvePortalText(portal.commerceLandingPageNoAccessButtonLabel, 'commerceLandingPageNoAccessButtonLabel');
        let action;
        if (hasAccess) {
            action = item.isProgram() ? startProgram : nav.deliveryPage(item);
        }
        else if (item.isCourse()) {
            action = nav.courseCheckout(item.key);
        }
        else {
            action = nav.programCheckout(item.key);
        }
        const showPrice = portal.cardShowPrice && !hasAccess;
        return {
            showPrice,
            buttonLabel,
            action,
            instructorAction: nav.instructorAction,
        };
    }
    throw Error(`Portal type not recognized ${portal.type}`);
};
// Meeting status is based on the status property of the meeting except
// that the status for OPEN happens when the meeting is in the open period, or active
export const calcMeetingStatus = (meeting) => {
    if (['CANCELLED', 'POST_MEETING', 'ACTIVE', 'OPEN'].includes(meeting.status)) {
        return meeting.status;
    }
    if (meeting.status === 'PRE_MEETING') {
        const now = dayjs();
        // if its before the start time plus the open period then its pre meeting
        if (now.isAfter(dayjs(meeting.startsAt).subtract(meeting.preStartOpenDuration || 5, 'minute'))) {
            return 'OPEN';
        }
        return 'PRE_MEETING';
    }
    console.error('did not determine meeting status', meeting);
    return 'UNKNOWN';
};
export const configMeetingPage = (store, meeting, meetingRegistration, navigate, location, rootPath, isPortal) => {
    const nav = navigationActions(navigate, location, rootPath);
    console.log('configMeetingPage', { meeting, meetingRegistration });
    const registerForMeeting = async () => {
        console.log('registering for meeting', meeting.key);
        const result = await store.registerForMeeting(meeting.key);
        console.log('registered for meeting', result);
        return result;
    };
    const joinMeeting = async () => {
        console.log('joining meeting', meeting.key);
        const registrationResult = await store.registerForMeeting(meeting.key);
        const result = await store.joinMeeting(meeting.key);
        console.log('joined for meeting', result, registrationResult);
        return result;
    };
    const startMeeting = async () => {
        console.log('Starting meeting', meeting.key);
        const result = await store.startMeeting(meeting.key);
        const registrationResult = await store.registerForMeeting(meeting.key);
        const joinResult = await store.joinMeeting(meeting.key);
        console.log('Meeting started', result, joinResult, registrationResult);
        return result;
    };
    // need to be signed in to do anything
    if (store.isAnonymous) {
        return {
            buttonLabel: 'Sign-in to Register',
            action: undefined,
            instructorAction: nav.instructorAction,
        };
    }
    const meetingStatus = calcMeetingStatus(meeting);
    // signed-in, we can be either pre-meeting, active or post-meeting
    if (meetingStatus === 'PRE_MEETING') {
        if (meetingRegistration?.status === 'REGISTERED') {
            return {
                buttonLabel: store.currentPortal.getToken('registeredLabel'),
                action: undefined,
                instructorAction: nav.instructorAction,
            };
        }
        if (meetingRegistration?.status === 'INVITED') {
            return {
                buttonLabel: store.currentPortal.getToken('acceptInviteLabel'),
                action: registerForMeeting,
                instructorAction: nav.instructorAction,
            };
        }
        /* options are:
        * Register - meeting supports registration, and user has permission to register
        * Sign-in to Register - meeting supports registration, but user needs to sign in to register
        * Registered - user is registered for the meeting
        * Registration Closed
        */
        return {
            buttonLabel: store.currentPortal.getToken('registerLabel'),
            action: registerForMeeting,
            instructorAction: nav.instructorAction,
        };
    }
    if (meetingStatus === 'OPEN') {
        if (!isPortal) {
            return {
                buttonLabel: store.currentPortal.getToken('startMeetingLabel'),
                action: startMeeting,
                instructorAction: nav.instructorAction,
            };
        }
        if (!meeting?.registrationRequired && meetingRegistration?.status === 'REGISTERED') {
            return {
                buttonLabel: 'Waiting for host to start the meeting',
                action: undefined,
                instructorAction: nav.instructorAction,
            };
        }
        return {
            buttonLabel: store.currentPortal.getToken('registerLabel'),
            action: registerForMeeting,
            instructorAction: nav.instructorAction,
        };
    }
    if (meetingStatus === 'ACTIVE') {
        if (meeting?.registrationRequired) {
            if (meetingRegistration?.status === 'REGISTERED'
                || meetingRegistration?.status === 'INVITED'
                || store.currentCustomer.isAdmin()) {
                return {
                    buttonLabel: store.currentPortal.getToken('joinMeetingLabel'),
                    action: joinMeeting,
                    instructorAction: nav.instructorAction,
                };
            }
            return {
                buttonLabel: store.currentPortal.getToken('registerLabel'),
                action: registerForMeeting,
                instructorAction: nav.instructorAction,
            };
        }
        return {
            buttonLabel: store.currentPortal.getToken('joinMeetingLabel'),
            action: joinMeeting,
            instructorAction: nav.instructorAction,
        };
    }
    // post-meeting
    if (meetingStatus === 'POST_MEETING') {
        /* options are:
        * Register - meeting supports registration, and user has permission to register
        * Sign-in to Register - meeting supports registration, but user needs to sign in to register
        * Registered - user is registered for the meeting
        * Registration Closed
        */
        if (meeting.checkAccess()) {
            if (!meetingRegistration) {
                return {
                    buttonLabel: 'Register to View Recording',
                    action: registerForMeeting,
                    instructorAction: nav.instructorAction,
                };
            }
            if (hasRecording(meeting)) {
                return {
                    buttonLabel: store.currentPortal.getToken('viewRecordingLabel'),
                    action: nav.landingPage(meeting),
                    instructorAction: nav.instructorAction,
                };
            }
            return {
                buttonLabel: 'Processing recording..',
                action: undefined,
                instructorAction: nav.instructorAction,
            };
        }
    }
    return {
        buttonLabel: 'You do not have access to this meeting.',
        action: undefined,
        instructorAction: nav.instructorAction,
    };
};
//# sourceMappingURL=portalConfig.js.map